<template>
  <div>
    <div class="card card-custom gutter-b" style="box-shadow: none">
      <div class="card-header card-header-tabs-line">
        <ul
          class="nav nav-dark nav-bold nav-tabs nav-tabs-line"
          role="tablist"
          ref="builder-tab"
        >
          <li class="nav-item">
            <a
              class="nav-link active"
              data-tab="0"
              data-toggle="tab"
              href="#"
              role="tab"
            >
              Cadastro
            </a>
          </li>
        </ul>
      </div>

      <b-form class="form" @submit.stop.prevent="onSubmit">
        <div class="card-body">
          <b-tabs class="hide-tabs" v-model="tabIndex">
            <b-tab active>
              <b-row>
                <b-col md="4">
                  <b-col>
                    <b-form-group
                      :class="{ 'required-field': !form.nome }"
                      id="nome"
                      label-for="nome"
                      label="Descrição"
                    >
                      <b-form-input
                        v-model="$v.form.nome.$model"
                        :state="validateState('nome')"
                        autofocus
                      >
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                </b-col>
                <b-col md="2">
                  <b-col>
                    <b-form-group
                      :class="{ 'required-field': !form.sigla }"
                      id="sigla"
                      label-for="sigla"
                      label="Sigla"
                    >
                      <b-form-input
                        v-model="$v.form.sigla.$model"
                        :state="validateState('sigla')"
                      >
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                </b-col>
                <b-col md="2">
                  <b-col>
                    <b-form-group
                      id="conversor"
                      label-for="conversor"
                      label="Conversor"
                    >
                      <money
                        class="form-control"
                        v-model="form.conversor"
                        v-bind="configMoney"
                      >
                      </money>
                    </b-form-group>
                  </b-col>
                </b-col>
                <b-col md="2">
                  <b-col>
                    <b-form-group
                      id="tipo_conversor"
                      label-for="tipo_conversor"
                      label="Tipo da conversão"
                    >
                      <select
                        name="tipo_conversor"
                        id="tipo_conversor"
                        v-model="form.tipo_conversor"
                        class="form-control"
                      >
                        <option
                          v-for="(t, index) in tiposConversor"
                          :value="t.id"
                          :key="'tipo' + index"
                        >
                          {{ t.descricao }}
                        </option>
                      </select>
                    </b-form-group>
                  </b-col>
                </b-col>
                <b-col md="2">
                  <b-col>
                    <b-form-group
                      id="unidade_tributavel"
                      label-for="unidade_tributavel"
                      label="Unidade tributável"
                    >
                      <VueSelect
                        id="unidade_tributavel"
                        v-model="form.unidade_tributavel"
                        label="sigla"
                        :options="unidadesMedidas"
                        :reduce="(unidade) => unidade.id"
                        :clearable="true"
                        placeholder="Opcional"
                      >
                        <template slot="option" slot-scope="option">
                          {{ option.sigla }} - {{ option.nome }}
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          {{ option.sigla }} - {{ option.nome }}
                        </template>
                        <template slot="no-options">
                          Nenhuma unidade encontrada
                        </template>
                      </VueSelect>
                    </b-form-group>
                  </b-col>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </div>

        <div class="card-footer">
          <div class="row">
            <div class="col-lg-12" style="text-align: center">
              <button
                type="submit"
                ref="submit_nova_un"
                class="btn btn-primary font-weight-bold"
              >
                Salvar
              </button>
              <router-link
                class="btn btn-clean font-weight-bold"
                :to="{
                  name: 'unidades',
                }"
              >
                Cancelar
              </router-link>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { SistemaMixin } from "@/modules/Application";
import UNData, { UNDataRequired } from "./UNData";
import { mapGetters } from "vuex";
import { Money } from "v-money";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { MONEY as settingMoney } from "@/modules/Application";
import { onboardStore } from "../../../onboardStore";

export default {
  name: "app-un-form",
  props: {
    url: {
      type: String,
    },
    un: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [validationMixin, SistemaMixin],
  data() {
    return {
      onboardStore,
      tabIndex: 0,
      form: {},
      configMoney: settingMoney,
      tiposConversor: [
        {
          id: 1,
          descricao: "Multiplição",
        },
        {
          id: 2,
          descricao: "Divisão",
        },
      ],
      unidadesMedidas: [],
    };
  },
  validations: {
    form: UNDataRequired,
  },
  components: {
    Money,
    VueSelect,
  },
  watch: {
    un(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.form = newValue;
      }
    },
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }

    this.getDataInit();
  },
  methods: {
    async getDataInit() {
      this.form = await new UNData({});
      this.unidadesMedidas = await this.getUnidadeMedidas();
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_nova_un"];

      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          return;
        }

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");

        await this.$http.post(this.url, this.form);
        if (this.onboardStore.currentStep > 0) {
          this.onboardStore.currentStep = 6;
        }
        this.$router.push({ name: "unidades" });
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
      }
    },
  },
};
</script>

<style>
.vs__dropdown-toggle {
  border: 2px solid #dedede;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 6px;
  outline: none;
  height: 38px;
}
</style>
